// ----------------- Entry North Wall ------------------- //

import IntelligenceBeauty from '../../assets/images/entry-north/1-intelligence-beauty-love.webp';
import DogsRule from '../../assets/images/entry-north/2-dogs-rule-world.webp';

// ----------------- Entry East Wall ------------------ //

import Challenges from '../../assets/images/entry-east/3-challenges.webp';
import ArtScience from '../../assets/images/entry-east/4-marriage-art-science.webp';
import Venus from '../../assets/images/entry-east/5-venus.webp';
import ItsTime from '../../assets/images/entry-east/6-its-time.webp';
import Neptunes2 from '../../assets/images/entry-east/7-neptunes-confront-pollution.webp';
import TheDream from '../../assets/images/entry-east/8-the-dream.webp';
import Evan from '../../assets/images/entry-east/9-evan.webp';

// ----------------- Entry South Wall ------------------ //

import WrongScore from '../../assets/images/entry-south/10-wrong-score.webp';

// ----------------- Entry West Wall ------------------ //

import AnotherArrival from '../../assets/images/entry-west/11-another-arrival-black-hole.webp';
import Getaway from '../../assets/images/entry-west/12-fast-getaway.webp';
import Spotlight from '../../assets/images/entry-west/13-moving-the-spotlight.webp';
import Art from '../../assets/images/entry-west/14-art.webp';
import MothersTurn from '../../assets/images/entry-west/15-mothers-turn.webp';

// ----------------- Main Room North Wall ------------------- //

import Sam from '../../assets/images/main-room-north/16-sam.webp'
import Undershirt from '../../assets/images/main-room-north/17-undershirt.webp'
import Strength from '../../assets/images/main-room-north/18-strength-tarot.webp';
import Working from '../../assets/images/main-room-north/19-working-here.webp';
import Dispatch from '../../assets/images/main-room-north/20-dispatch.webp';
import Chicken from '../../assets/images/main-room-north/21-the-chicken.webp';
import Hermit from '../../assets/images/main-room-north/22-hermit-tarot.webp';
import Empress from '../../assets/images/main-room-north/23-empress-tarot.webp';
import Emperor from '../../assets/images/main-room-north/24-emperor-tarot.webp';
import Divine from '../../assets/images/main-room-north/25-divine-intervention.webp';
import Cupid from '../../assets/images/main-room-north/26-enter-cupid.webp';
import Magician from '../../assets/images/main-room-north/27-magician-tarot.webp';
import Ed from '../../assets/images/main-room-north/28-ed.webp';
import Crayolas from '../../assets/images/main-room-north/29-crayolas-amazed.webp';
import Launch from '../../assets/images/main-room-north/30-ready-for-launch.webp';
import Reflection from '../../assets/images/main-room-north/31-upon-reflection.webp'
import ViolinAngel from '../../assets/images/main-room-north/32-violin-angel.webp';
import PriestessThumb from '../../assets/images/main-room-north/33-high-priestess-tarot.webp';
import SmileThumb from '../../assets/images/main-room-north/34-the-smile.webp';
import IceCreamThumb from '../../assets/images/main-room-north/35-still-ice-cream.webp';
import DrowningDevilThumb from '../../assets/images/main-room-north/36-drowning-out-devil.webp';
import ReimaginingExodusThumb from '../../assets/images/main-room-north/37-retelling-exodus.webp';
import YouGoDown from '../../assets/images/main-room-north/38-you-go-down.webp';
import Jaded from '../../assets/images/main-room-north/39-jaded.webp';
import BlackRabbi from '../../assets/images/main-room-north/40-black-rabbi.webp';
import NeverFeel from '../../assets/images/main-room-north/41-never-feel.webp';
import Mystic from '../../assets/images/main-room-north/42-mystic.webp';
import LiftOff from '../../assets/images/main-room-north/43-lift-off.webp';
import Parallel from '../../assets/images/main-room-north/44-parallel-universe.webp';
import GoldenEgg from '../../assets/images/main-room-north/45-golden-egg-arrives.webp';
import SearchIdentity from '../../assets/images/main-room-north/46-search-for-identity.webp';
import Summer from '../../assets/images/main-room-north/47-summer-2002.webp';
import Actor from '../../assets/images/main-room-north/48-actor.webp';
import HeKissedMe from '../../assets/images/main-room-north/49-he-kissed-me.webp';
import Remembering from '../../assets/images/main-room-north/50-remembering.webp';
import FirstJob from '../../assets/images/main-room-north/51-first-on-the-job.webp';
import FirstNote from '../../assets/images/main-room-north/52-first-note.webp';
import YourVacation from '../../assets/images/main-room-north/53-coming-for-your-vacation.webp';
import JadedClown from '../../assets/images/main-room-north/54-another-jaded-clown.webp';
import Premonition from '../../assets/images/main-room-north/55-stop-premonition.webp';
import DessertChef from '../../assets/images/main-room-north/56-dessert-chef.webp';
import WhiteClown from '../../assets/images/main-room-north/57-white-clown.webp';
import GalleryHeaven from '../../assets/images/main-room-north/58-gallery-heaven.webp';
import StopFollowing from '../../assets/images/main-room-north/59-stop-following.webp';
import Caryatids from '../../assets/images/main-room-north/60-revolt-of-caryatids.webp';
import DadAndThreeEggs from '../../assets/images/main-room-north/61-dad-and-three-eggs.webp';

// ----------------- Main Room North/Exit ------------------- //

import America from '../../assets/images/main-room-north-exit/62-welcome-to-america.webp';
import LookAtMe from '../../assets/images/main-room-north-exit/63-look-at-me.webp';
import Captain from '../../assets/images/main-room-north-exit/64-the-captain.webp';
import HouseCards from '../../assets/images/main-room-north-exit/65-house-of-cards.webp';

// ----------------- Main Room Stage Alcove ------------------- //

import MusicApp from '../../assets/images/stage-alcove/66-installing-music-app.webp';
import Distancing from '../../assets/images/stage-alcove/67-social-distancing.webp';
import FeedFrog from '../../assets/images/stage-alcove/68-time-to-feed-frog.webp';
import HouseHorrors from '../../assets/images/stage-alcove/69-leaving-house-of-horrors.webp';
import NeededSurgery from '../../assets/images/stage-alcove/70-much-needed-surgery.webp';
import SafeTravel from '../../assets/images/stage-alcove/71-safe-travel.webp';
import BlackHole from '../../assets/images/stage-alcove/72-arrival-through-black-hole.webp';
import MaryPoppins from '../../assets/images/stage-alcove/73-martian-mary-poppins.webp';
import RecentTimes from '../../assets/images/stage-alcove/74-fool-in-recent-times.webp';
import Homecoming from '../../assets/images/stage-alcove/75-homecoming-for-lost-tambourine.webp';
import KindredSpirits from '../../assets/images/stage-alcove/76-kindred-spirits.webp';
import Flip from '../../assets/images/stage-alcove/77-flip.webp';
import YouFirst from '../../assets/images/stage-alcove/78-you-first.webp';
import Afternoon from '../../assets/images/stage-alcove/79-another-afternoon.webp';
import BirdSanctuary from '../../assets/images/stage-alcove/80-bird-sanctuary.webp';
import Neptunes1 from '../../assets/images/stage-alcove/81-neptunes-confront-us-2.webp';
import Wrestling from '../../assets/images/stage-alcove/82-jacob-wrestling-angel.webp';
import LastVoyage from '../../assets/images/stage-alcove/83-last-voyage.webp';
import Enlightenment from '../../assets/images/stage-alcove/84-moment-of-enlightenment.webp';
import Try from '../../assets/images/stage-alcove/85-try.webp';
import Practice from '../../assets/images/stage-alcove/86-practice.webp';
import BetterThan from '../../assets/images/stage-alcove/87-better-than-that.webp';
import Direction from '../../assets/images/stage-alcove/88-choose-direction.webp';

// ----------------- Main Room Stage/East ------------------- //

import PastBehind from '../../assets/images/stage-east/89-leaving-past-behind.webp';
import Sad from '../../assets/images/stage-east/90-sad.webp';
import Lost from '../../assets/images/stage-east/91-lost-between-planets.webp';
import Untitled92 from '../../assets/images/stage-east/92-untitled.webp';
import Realities from '../../assets/images/stage-east/93-different-realities.webp';
import RiverStyx from '../../assets/images/stage-east/94-river-styx.webp';
import Dorothy from '../../assets/images/stage-east/95-dorothy.webp';
import SunnySide from '../../assets/images/stage-east/96-sunny-side-up.webp';
import JacobsDream from '../../assets/images/stage-east/97-jacobs-dream.webp';
import LunchReady from '../../assets/images/stage-east/98-lunch-ready.webp';
import RedRope from '../../assets/images/stage-east/99-red-rope.webp';
import SeeMe from '../../assets/images/stage-east/100-see-me.webp';
import TheUnknown from '../../assets/images/stage-east/101-into-the-unknown.webp';
import NoFriends from '../../assets/images/stage-east/102-no-friends.webp';
import ButterflyWoman from '../../assets/images/stage-east/103-butterfly-woman.webp';
import Gifts from '../../assets/images/stage-east/104-gifts.webp';
import Guardian from '../../assets/images/stage-east/105-guardian.webp';

// ----------------- Main Room South Wall ----------------- //

import Purification from '../../assets/images/main-room-south/106-purification-of-thought.webp';
import Resist from '../../assets/images/main-room-south/107-resist.webp';
import Surgery2 from '../../assets/images/main-room-south/108-reconstructive-surgery-no2.webp';
import Crossroads from '../../assets/images/main-room-south/109-devil-crossroads-cello.webp';
import BullRing from '../../assets/images/main-room-south/110-retired-from-bullring.webp';
import KingCats from '../../assets/images/main-room-south/111-king-of-cats.webp';
import EggedOn from '../../assets/images/main-room-south/112-egged-on.webp';
import TooFar from '../../assets/images/main-room-south/113-gone-too-far.webp';
import LookingAhead from '../../assets/images/main-room-south/114-looking-ahead.webp';
import Opera from '../../assets/images/main-room-south/115-opera-from-mezzanine.webp';
import StateOfWorld from '../../assets/images/main-room-south/116-state-of-world.webp';
import GiantEgg from '../../assets/images/main-room-south/117-passing-giant-egg.webp';
import OuttaHere from '../../assets/images/main-room-south/118-outta-here.webp';
import PaintersMuseum from '../../assets/images/main-room-south/119-painters-museum.webp';
import PrivateShowing from '../../assets/images/main-room-south/120-private-showing.webp';
import Roadhouse from '../../assets/images/main-room-south/121-roadhouse-full-moon.webp';
import CenterStage from '../../assets/images/main-room-south/122-center-stage.webp';
import Conservationist from '../../assets/images/main-room-south/123-conservationist.webp';
import Traveler from '../../assets/images/main-room-south/124-spiritual-traveler.webp';
import GoodCheer from '../../assets/images/main-room-south/125-of-good-cheer.webp';
import YearsLater from '../../assets/images/main-room-south/126-years-later-cigarette.webp';
import Bob from '../../assets/images/main-room-south/127-bob.webp';
import QuestionableMoves from '../../assets/images/main-room-south/128-questionable-moves.webp';
import BackToSea from '../../assets/images/main-room-south/129-back-to-sea.webp';
import Dubious from '../../assets/images/main-room-south/130-dubious.webp';
import Dervish1 from '../../assets/images/main-room-south/131-dervish-no1.webp';
import Dervish2 from '../../assets/images/main-room-south/132-dervish-no2.webp';
import Helena from '../../assets/images/main-room-south/133-helena.webp';
import DealWithDevil from '../../assets/images/main-room-south/134-soul-breaks-deal.webp';
import Waiting from '../../assets/images/main-room-south/135-waiting-for-parting.webp';
import Higher from '../../assets/images/main-room-south/136-higher.webp';
import OhJesus from '../../assets/images/main-room-south/137-jesus-christ.webp';

// ----------------- Main Room West Wall ------------------ //

import Probed from '../../assets/images/main-room-west/138-probed.webp';
import DevilsRing from '../../assets/images/main-room-west/139-devils-ring.webp';
import DayBeach from '../../assets/images/main-room-west/140-day-beach-1.webp';
import Mutiny from '../../assets/images/main-room-west/141-mutiny.webp';
import CatchRelease from '../../assets/images/main-room-west/142-catch-release.webp';

// --------------------------- Stairwell ---------------------------- //

// ----------------- Stairwell North ------------------ //
import WhiteClown2 from '../../assets/images/stairwell/143-white-clown-2.webp';
import Dervish3 from '../../assets/images/stairwell/144-dervish-3.webp';
import Jester from '../../assets/images/stairwell/145-jester.webp';
import Untitled from '../../assets/images/stairwell/146-untitled.webp';
import FlightSchool from '../../assets/images/stairwell/147-flight-school.webp';
import BreakfastChef from '../../assets/images/stairwell/148-breakfast-chef.webp';
import LeavingHome from '../../assets/images/stairwell/149-leaving-home.webp';
import MuseumDisasters from '../../assets/images/stairwell/150-museum-of-disasters.webp';
import Brunhilda from '../../assets/images/stairwell/151-brunhilda.webp';
import PayAdvance from '../../assets/images/stairwell/152-pay-in-advance.webp';
import Arrival from '../../assets/images/stairwell/153-arrival.webp';
import BetterPlace from '../../assets/images/stairwell/154-a-better-place.webp';
import InReadiness from '../../assets/images/stairwell/155-in-readiness.webp';
import CheckMate from '../../assets/images/stairwell/156-check-mate.webp';
import Doctors from '../../assets/images/stairwell/157-a-fear-of-doctors.webp';
import TheChariot from '../../assets/images/stairwell/158-the-chariot-tarot.webp';
import OutOfReach from '../../assets/images/stairwell/159-out-of-reach.webp';
import Red from '../../assets/images/stairwell/160-red.webp';
import Surprised from '../../assets/images/stairwell/161-surprised.webp';

// ----------------- Stairwell East ------------------ //
import WithBrother from '../../assets/images/stairwell/162-trip-with-brother.webp';
import BestOfShow from '../../assets/images/stairwell/163-best-of-show.webp';
import Sainted from '../../assets/images/stairwell/164-sainted.webp';
import SixDogs from '../../assets/images/stairwell/165-six-dogs.webp';
import Fighting from '../../assets/images/stairwell/166-we-were-fighting.webp';

// ----------------- Stairwell South ------------------ //
import Sense from '../../assets/images/stairwell/167-nothing-makes-sense.webp';
import Going from '../../assets/images/stairwell/168-where-are-you-going.webp';
import Eggs from '../../assets/images/stairwell/169-eggs.webp';
import MotherRocket from '../../assets/images/stairwell/170-no-mother-rocket.webp';
import Divas from '../../assets/images/stairwell/171-divas.webp';
import ColdWind from '../../assets/images/stairwell/172-a-cold-wind.webp';
import Voices from '../../assets/images/stairwell/173-voices-of-doom.webp';
import Matrimony from '../../assets/images/stairwell/174-unholy-matrimony.webp';
import Anger from '../../assets/images/stairwell/175-anger.webp';
import Overqualified from '../../assets/images/stairwell/176-overqualified.webp';
import Peghead from '../../assets/images/stairwell/177-peghead.webp';
import Decoration from '../../assets/images/stairwell/178-decoration.webp';
import ReEntry from '../../assets/images/stairwell/179-re-entry.webp';
import Wiser from '../../assets/images/stairwell/180-older-but-wiser.webp';
import Worker from '../../assets/images/stairwell/181-worker.webp';
import Demo from '../../assets/images/stairwell/182-demo.webp';
import BentNote from '../../assets/images/stairwell/183-the-bent-note.webp';

// ----------------- Stairwell West ------------------ //
import WhatSound from '../../assets/images/stairwell/184-what-was-that-sound.webp';
import Downstairs from '../../assets/images/stairwell/185-going-downstairs-for-ideas.webp';
import Gossip from '../../assets/images/stairwell/186-paint-hadnt-even-dried.webp';
import Heirophant from '../../assets/images/stairwell/187-the-heirophant-tarot.webp';


// --------------------------- Green Room ---------------------------- //

// ----------------- Green Room North ------------------ //
import WomanInCharge from '../../assets/images/green-room/188-put-a-woman-in-charge.webp';
import Devil from '../../assets/images/green-room/189-the-devil.webp';
import Untitled2 from '../../assets/images/green-room/190-untitled-2.webp';
import WheelFortune from '../../assets/images/green-room/191-wheel-of-fortune.webp';
import Justice from '../../assets/images/green-room/192-justice.webp';
import Untitled3 from '../../assets/images/green-room/193-untitled-3.webp';
import HelpArrives from '../../assets/images/green-room/194-help-arrives.webp';
import Tooth from '../../assets/images/green-room/195-tooth.webp';
import Bill from '../../assets/images/green-room/196-bill.webp';

// ----------------- Green Room East ------------------ //
import OtherSide from '../../assets/images/green-room/197-the-other-side.webp';
import RiseAbove from '../../assets/images/green-room/198-rise-above.webp';
import Misgivings from '../../assets/images/green-room/199-misgivings-over-his-hat.webp';
import Medicine from '../../assets/images/green-room/200-take-your-medicine.webp';
import SongOfLove from '../../assets/images/green-room/201-the-song-of-love.webp';
import DashedDreams from '../../assets/images/green-room/202-reflecting-on-the-dashed-dreams.webp';
import TooLate from '../../assets/images/green-room/203-too-late.webp';
import Beatrice from '../../assets/images/green-room/204-beatrice.webp';
import Danger from '../../assets/images/green-room/205-danger.webp';
import Rendezvous from '../../assets/images/green-room/206-midnight-rendezvous.webp';
import Cooks from '../../assets/images/green-room/207-cooks-on-break.webp';
import Autumn33 from '../../assets/images/green-room/208-the-autumn-of-33.webp';

// ----------------- Green Room South ------------------ //
import EntertainmentChange from '../../assets/images/green-room/209-the-entertainment-at-climate-change.webp';
import ToMexico from '../../assets/images/green-room/210-to-mexico.webp';
import GoldenMountain from '../../assets/images/green-room/211-marathon-to-golden-mountain.webp';
import ClimateChange from '../../assets/images/green-room/212-climate-change-on-your-vacation.webp';
import Untitled4 from '../../assets/images/green-room/213-untitled-4.webp';
import Marge from '../../assets/images/green-room/214-marge.webp';

// ----------------- Green Room West ------------------ //
import Judgement from '../../assets/images/green-room/215-judgement.webp';
import Untitled6 from '../../assets/images/green-room/216-untitled-6.webp';
import Transparent from '../../assets/images/green-room/217-transparent.webp';
import Stunned from '../../assets/images/green-room/218-stunned-by-the-beauty-of-night.webp';
import Transport from '../../assets/images/green-room/219-transport-to-a-better-place.webp';
import NoSmoking from '../../assets/images/green-room/220-no-smoking-here.webp';
import Death from '../../assets/images/green-room/221-death-from-the-tarot.webp';
import Sherpa from '../../assets/images/green-room/222-sherpa-carrying-the-burden.webp';
import Flocking from '../../assets/images/green-room/223-people-flocking-to-the-painters-museum.webp';
import PaintMeHappy from '../../assets/images/green-room/224-paint-me-happy.webp';
import Go from '../../assets/images/green-room/225-go.webp';


// ----------------- Green Room Column ------------------ //
import DontWorry from '../../assets/images/green-room/226-dont-worry-be-happy.webp';
import Advice from '../../assets/images/green-room/227-we-could-use-some-advice.webp';
import NaturalHistory from '../../assets/images/green-room/228-the-museum-of-natural-history.webp';
import Conclave from '../../assets/images/green-room/229-conclave.webp';
import Quarantined from '../../assets/images/green-room/230-quarantined.webp';

// ---------------------------------------- Audio Files ------------------------------------------ //

// ----------------- Entry North ------------------ //
import IntelligenceAudio from '../../assets/audio/entry/intelligence-beauty-love.mp3'

// ----------------- Entry East ------------------ //
import MarriageAudio from '../../assets/audio/entry/marriage-of-art-and-science.mp3'
import VenusAudio from '../../assets/audio/entry/venus.mp3'

// ----------------- Entry South ------------------ //
import WrongScoreAudio from '../../assets/audio/entry/the-wrong-score.mp3'

// ----------------- Entry West ------------------ //
import AnotherArrivalAudio from '../../assets/audio/entry/another-arrival-through-the-black-hole.mp3'
import FastGetawayAudio from '../../assets/audio/entry/fast-getaway.mp3'
import SpotlightAudio from '../../assets/audio/entry/moving-the-spotlight.mp3'
import ArtAudio from '../../assets/audio/entry/art.mp3'
import MothersTurnAudio from '../../assets/audio/entry/mothers-turn.mp3'

// ----------------- Main North ------------------ //
import ChickenAudio from '../../assets/audio/main-room/the-chicken.mp3'
import DivineAudio from '../../assets/audio/main-room/divine-intervention.mp3'
import HappinessAudio from '../../assets/audio/main-room/happiness.mp3'
import IceCreamAudio from '../../assets/audio/main-room/we-still-have-ice-cream.mp3'
import DrowningDevilAudio from '../../assets/audio/main-room/drowning-out-the-devil.mp3'
import ExodusAudio from '../../assets/audio/main-room/exodus.mp3'
import LiftOffAudio from '../../assets/audio/main-room/lift-off.mp3'
import ParallelUniverseAudio from '../../assets/audio/main-room/parallel-universe.mp3'
import GoldenEggAudio from '../../assets/audio/main-room/the-golden-egg-arrives.mp3'
import IdentityAudio from '../../assets/audio/main-room/in-the-search-for-identity.mp3'
import GalleryHeavenAudio from '../../assets/audio/main-room/a-gallery-in-heaven.mp3'

// ----------------- Main North/Exit ------------------ //
import LookAtMeAudio from '../../assets/audio/main-room/look-at-me.mp3'
import HouseCardsAudio from '../../assets/audio/main-room/house-of-cards.mp3'

// ----------------- Main East ------------------ //
import PastBehindAudio from '../../assets/audio/main-room/leaving-the-past-behind.mp3'

// ----------------- Stage Alcove ------------------ //
import Neptunes2Audio from '../../assets/audio/alcove/once-again-the-neptunes.mp3'

// ----------------- Stage ------------------ //
import SunnySideAudio from '../../assets/audio/main-room/sunnyside-up.mp3'

// ----------------- Main South ------------------ //
import ResistanceAudio from '../../assets/audio/main-room/resistance.mp3'
import SurgeryAudio from '../../assets/audio/main-room/reconstructive-surgery.mp3'
import TooFarAudio from '../../assets/audio/main-room/this-time-youve-gone-too-far.mp3'
import StateOfWorldAudio from '../../assets/audio/main-room/the-state-of-the-world.mp3'
import OuttaHereAudio from '../../assets/audio/main-room/im-outta-here.mp3'
import MuseumAudio from '../../assets/audio/main-room/painters-museum.mp3'
import ShowingAudio from '../../assets/audio/main-room/private-showing.mp3'
import RoadhouseAudio from '../../assets/audio/main-room/roadhouse-at-the-full-moon.mp3'
import SpiritualTouristAudio from '../../assets/audio/main-room/spiritual-tourist.mp3'
import QuestionableMovesAudio from '../../assets/audio/main-room/questionable-moves.mp3'
import ThePartingAudio from '../../assets/audio/main-room/waiting-for-the-parting.mp3'
import HigherAudio from '../../assets/audio/main-room/higher.mp3'
import JesusChristAudio from '../../assets/audio/main-room/oh-jesus-christ.mp3'

// ----------------- Main West ------------------ //
import ProbedAudio from '../../assets/audio/main-room/probed.mp3'
import DevilsRingAudio from '../../assets/audio/main-room/playing-for-the-devils-ring.mp3'
import BeachAudio from '../../assets/audio/main-room/another-day-at-the-beach.mp3'
import MutinyAudio from '../../assets/audio/main-room/mutiny.mp3'

// ----------------- Green Room ------------------ //
import AutumnAudio from '../../assets/audio/green-room/autumn-of-33.mp3'
import SongOfLoveAudio from '../../assets/audio/green-room/song-of-love.mp3'
import OtherSideAudio from '../../assets/audio/green-room/the-other-side.mp3'
import TheSherpaAudio from '../../assets/audio/green-room/the-sherpa.mp3'

//------------------------------------ End ------------------------------------ //

export const directory = [
    {
      id: 1,
      imgSrc: IntelligenceBeauty,
      thumbSrc: `/.netlify/images?url=${IntelligenceBeauty}&w=400`,
      title: "Intelligence, Beauty, Love",
      audio: IntelligenceAudio,
    },
    {
      id: 2,
      imgSrc: DogsRule,
      thumbSrc: `/.netlify/images?url=${DogsRule}&w=400`,
      title: "When Dogs Rule the World",
      audio: null,
    },
    {
      id: 3,
      imgSrc: Challenges,
      thumbSrc: `/.netlify/images?url=${Challenges}&w=400`,
      title: "Challenges",
      audio: null,
    },
    {
      id: 4,
      imgSrc: ArtScience,
      thumbSrc: `/.netlify/images?url=${ArtScience}&w=400`,
      title: "Another Marriage of Art and Science",
      audio: MarriageAudio,
    },
    {
      id: 5,
      imgSrc: Venus,
      thumbSrc: `/.netlify/images?url=${Venus}&w=400`,
      title: "Venus",
      audio: VenusAudio,
    },
    {
      id: 6,
      imgSrc: ItsTime,
      thumbSrc: `/.netlify/images?url=${ItsTime}&w=400`,
      title: "It's Time",
      audio: null,
    },
    {
      id: 7,
      imgSrc: Neptunes2,
      thumbSrc: `/.netlify/images?url=${Neptunes2}&w=400`,
      title: "Once Again the Neptunes Confront Us About the Pollution",
      audio: Neptunes2Audio,
    },
    {
      id: 8,
      imgSrc: TheDream,
      thumbSrc: `/.netlify/images?url=${TheDream}&w=400`,
      title: "The Dream",
      audio: null,
    },
    {
      id: 9,
      imgSrc: Evan,
      thumbSrc: `/.netlify/images?url=${Evan}&w=400`,
      title: "Evan",
      audio: null,
    },
    {
      id: 10,
      imgSrc: WrongScore,
      thumbSrc: `/.netlify/images?url=${WrongScore}&w=400`,
      title: "The Wrong Score",
      audio: WrongScoreAudio,
    },
    {
      id: 11,
      imgSrc: AnotherArrival,
      thumbSrc: `/.netlify/images?url=${AnotherArrival}&w=400`,
      title: "Another Arrival Through the Black Hole",
      audio: AnotherArrivalAudio,
    },
    {
      id: 12,
      imgSrc: Getaway,
      thumbSrc: `/.netlify/images?url=${Getaway}&w=400`,
      title: "Fast Getaway",
      audio: FastGetawayAudio,
    },
    {
      id: 13,
      imgSrc: Spotlight,
      thumbSrc: `/.netlify/images?url=${Spotlight}&w=400`,
      title: "Moving the Spotlight",
      audio: SpotlightAudio,
    },
    {
      id: 14,
      imgSrc: Art,
      thumbSrc: `/.netlify/images?url=${Art}&w=400`,
      title: "Art",
      audio: ArtAudio,
    },
    {
      id: 15,
      imgSrc: MothersTurn,
      thumbSrc: `/.netlify/images?url=${MothersTurn}&w=400`,
      title: "Mother's Turn",
      audio: MothersTurnAudio,
    },
    {
      id: 16,
      imgSrc: Sam,
      thumbSrc: `/.netlify/images?url=${Sam}&w=400`,
      title: "Sam",
      audio: null,
    },
    {
      id: 17,
      imgSrc: Undershirt,
      thumbSrc: `/.netlify/images?url=${Undershirt}&w=400`,
      title: "Undershirt",
      audio: null,
    },
    {
      id: 18,
      imgSrc: Strength,
      thumbSrc: `/.netlify/images?url=${Strength}&w=400`,
      title: "Strength (From the Tarot)",
      audio: null,
    },
    {
      id: 19,
      imgSrc: Working,
      thumbSrc: `/.netlify/images?url=${Working}&w=400`,
      title: "Can't You See I'm Working Here",
      audio: null,
    },
    {
      id: 20,
      imgSrc: Dispatch,
      thumbSrc: `/.netlify/images?url=${Dispatch}&w=400`,
      title: "Dispatch",
      audio: null,
    },
    {
      id: 21,
      imgSrc: Chicken,
      thumbSrc: `/.netlify/images?url=${Chicken}&w=400`,
      title: "The Chicken!",
      audio: ChickenAudio,
    },
    {
      id: 22,
      imgSrc: Hermit,
      thumbSrc: `/.netlify/images?url=${Hermit}&w=400`,
      title: "The Hermit (From the Tarot)",
      audio: null,
    },
    {
      id: 23,
      imgSrc: Empress,
      thumbSrc: `/.netlify/images?url=${Empress}&w=400`,
      title: "The Empress (From the Tarot)",
      audio: null,
    },
    {
      id: 24,
      imgSrc: Emperor,
      thumbSrc: `/.netlify/images?url=${Emperor}&w=400`,
      title: "The Emperor (From the Tarot)",
      audio: null,
    },
    {
      id: 25,
      imgSrc: Divine,
      thumbSrc: `/.netlify/images?url=${Divine}&w=400`,
      title: "Divine Intervention",
      audio: DivineAudio,
    },
    {
      id: 26,
      imgSrc: Cupid,
      thumbSrc: `/.netlify/images?url=${Cupid}&w=400`,
      title: "Enter Cupid",
      audio: null,
    },
    {
      id: 27,
      imgSrc: Magician,
      thumbSrc: `/.netlify/images?url=${Magician}&w=400`,
      title: "The Magician (From the Tarot)",
      audio: null,
    },
    {
      id: 28,
      imgSrc: Ed,
      thumbSrc: `/.netlify/images?url=${Ed}&w=400`,
      title: "Ed",
      audio: null,
   },
   {
      id: 29,
      imgSrc: Crayolas,
      thumbSrc: `/.netlify/images?url=${Crayolas}&w=400`,
      title: "The Crayolas Were Amazed by Their Own Skill",
      audio: null,
    },
    {
      id: 30,
      imgSrc: Launch,
      thumbSrc: `/.netlify/images?url=${Launch}&w=400`,
      title: "Ready for Launch",
      audio: null,
   },
    {
      id: 31,
      imgSrc: Reflection,
      thumbSrc: `/.netlify/images?url=${Reflection}&w=400`,
      title: "Upon reflection",
      audio: null,
    },
   {
      id: 32,
      imgSrc: ViolinAngel,
      thumbSrc: `/.netlify/images?url=${ViolinAngel}&w=400`,
      title: "Violin Angel",
      audio: null,
   },
    {
      id: 33,
      imgSrc: PriestessThumb,
      thumbSrc: `/.netlify/images?url=${PriestessThumb}&w=400`,
      title: "The High Priestess (From the Tarot)",
      audio: null,
    },
  {
      id: 34,
      imgSrc: SmileThumb,
      thumbSrc: `/.netlify/images?url=${SmileThumb}&w=400`,
      title: "Happiness",
      audio: HappinessAudio,
    },
    {
      id: 35,
      imgSrc: IceCreamThumb,
      thumbSrc: `/.netlify/images?url=${IceCreamThumb}&w=400`,
      title: "We Still Have Ice Cream (Eat Before Melting)",
      audio: IceCreamAudio,
    },
    {
      id: 36,
      imgSrc: DrowningDevilThumb,
      thumbSrc: `/.netlify/images?url=${DrowningDevilThumb}&w=400`,
      title: "Drowning Out the Devil",
      audio: DrowningDevilAudio,
   },
    {
      id: 37,
      imgSrc: ReimaginingExodusThumb,
      thumbSrc: `/.netlify/images?url=${ReimaginingExodusThumb}&w=400`,
      title: "Reimagining the Story of Exodus",
      audio: ExodusAudio,
    },
    {
      id: 38,
      imgSrc: YouGoDown,
      thumbSrc: `/.netlify/images?url=${YouGoDown}&w=400`,
      title: "I Watch You Go Down",
      audio: null,
    },
    {
      id: 39,
      imgSrc: Jaded,
      thumbSrc: `/.netlify/images?url=${Jaded}&w=400`,
      title: "Jaded",
      audio: null,
    },
    {
      id: 40,
      imgSrc: BlackRabbi,
      thumbSrc: `/.netlify/images?url=${BlackRabbi}&w=400`,
      title: "Black Rabbi",
      audio: null,
    },
    {
      id: 41,
      imgSrc: NeverFeel,
      thumbSrc: `/.netlify/images?url=${NeverFeel}&w=400`,
      title: "I Never Used to Feel This Way",
      audio: null,
    },
    {
      id: 42,
      imgSrc: Mystic,
      thumbSrc: `/.netlify/images?url=${Mystic}&w=400`,
      title: "Mystic",
      audio: null,
    },
    {
      id: 43,
      imgSrc: LiftOff,
      thumbSrc: `/.netlify/images?url=${LiftOff}&w=400`,
      title: "Lift Off",
      audio: LiftOffAudio,
    },
    {
      id: 44,
      imgSrc: Parallel,
      thumbSrc: `/.netlify/images?url=${Parallel}&w=400`,
      title: "Parallel Universe",
      audio: ParallelUniverseAudio,
    },
    {
      id: 45,
      imgSrc: GoldenEgg,
      thumbSrc: `/.netlify/images?url=${GoldenEgg}&w=400`,
      title: "The Golden Egg Arrives in the Nick of Time",
      audio: GoldenEggAudio,
    },
    {
      id: 46,
      imgSrc: SearchIdentity,
      thumbSrc: `/.netlify/images?url=${SearchIdentity}&w=400`,
      title: "In the Search for Identity",
      audio: IdentityAudio,
    },
    {
      id: 47,
      imgSrc: Summer,
      thumbSrc: `/.netlify/images?url=${Summer}&w=400`,
      title: "The Summer of 2002",
      audio: null,
    },
    {
      id: 48,
      imgSrc: Actor,
      thumbSrc: `/.netlify/images?url=${Actor}&w=400`,
      title: "Actor",
      audio: null,
    },
    {
      id: 49,
      imgSrc: HeKissedMe,
      thumbSrc: `/.netlify/images?url=${HeKissedMe}&w=400`,
      title: "He Kissed (Loves?) Me!",
      audio: null,
    },
    {
      id: 50,
      imgSrc: Remembering,
      thumbSrc: `/.netlify/images?url=${Remembering}&w=400`,
      title: "Remembering",
      audio: null,
    },
    {
      id: 51,
      imgSrc: FirstJob,
      thumbSrc: `/.netlify/images?url=${FirstJob}&w=400`,
      title: "First Day on the Job",
      audio: null,
    },
    {
      id: 52,
      imgSrc: FirstNote,
      thumbSrc: `/.netlify/images?url=${FirstNote}&w=400`,
      title: "The First Note",
      audio: null,
    },
    {
      id: 53,
      imgSrc: YourVacation,
      thumbSrc: `/.netlify/images?url=${YourVacation}&w=400`,
      title: "They're Coming for Your Vacation",
      audio: null,
    },
    {
      id: 54,
      imgSrc: JadedClown,
      thumbSrc: `/.netlify/images?url=${JadedClown}&w=400`,
      title: "Another Jaded Clown",
      audio: null,
    },
    {
      id: 55,
      imgSrc: Premonition,
      thumbSrc: `/.netlify/images?url=${Premonition}&w=400`,
      title: "Stop (The Premonition)",
      audio: null,
    },
    {
      id: 56,
      imgSrc: DessertChef,
      thumbSrc: `/.netlify/images?url=${DessertChef}&w=400`,
      title: "Dessert Chef",
      audio: null,
    },
    {
      id: 57,
      imgSrc: WhiteClown,
      thumbSrc: `/.netlify/images?url=${WhiteClown}&w=400`,
      title: "White Clown",
      audio: null,
    },
    {
      id: 58,
      imgSrc: GalleryHeaven,
      thumbSrc: `/.netlify/images?url=${GalleryHeaven}&w=400`,
      title: "A Gallery in Heaven",
      audio: GalleryHeavenAudio,
    },
    {
      id: 59,
      imgSrc: StopFollowing,
      thumbSrc: `/.netlify/images?url=${StopFollowing}&w=400`,
      title: "Stop Following Me",
      audio: null,
    },
    {
      id: 60,
      imgSrc: Caryatids,
      thumbSrc: `/.netlify/images?url=${Caryatids}&w=400`,
      title: "The Revolt of the Caryatids",
      audio: null,
    },
    {
      id: 61,
      imgSrc: DadAndThreeEggs,
      thumbSrc: `/.netlify/images?url=${DadAndThreeEggs}&w=400`,
      title: "Dad and Three Eggs",
      audio: null,
    },
    {
      id: 62,
      imgSrc: America,
      thumbSrc: `/.netlify/images?url=${America}&w=400`,
      title: "Welcome to America",
      audio: null,
    },
    {
      id: 63,
      imgSrc: LookAtMe,
      thumbSrc: `/.netlify/images?url=${LookAtMe}&w=400`,
      title: "Look At Me! Look At Me!",
      audio: LookAtMeAudio,
    },
    {
      id: 64,
      imgSrc: Captain,
      thumbSrc: `/.netlify/images?url=${Captain}&w=400`,
      title: "The Captain",
      audio: null,
    },
    {
      id: 65,
      imgSrc: HouseCards,
      thumbSrc: `/.netlify/images?url=${HouseCards}&w=400`,
      title: "House of Cards",
      audio: HouseCardsAudio,
    },
    {
      id: 66,
      imgSrc: MusicApp,
      thumbSrc: `/.netlify/images?url=${MusicApp}&w=400`,
      title: "Installing the Music App",
      audio: null,
    },
    {
      id: 67,
      imgSrc: Distancing,
      thumbSrc: `/.netlify/images?url=${Distancing}&w=400`,
      title: "Social Distancing",
      audio: null,
    },
    {
      id: 68,
      imgSrc: FeedFrog,
      thumbSrc: `/.netlify/images?url=${FeedFrog}&w=400`,
      title: "Time to Feed the Frog",
      audio: null,
    },
    {
      id: 69,
      imgSrc: HouseHorrors,
      thumbSrc: `/.netlify/images?url=${HouseHorrors}&w=400`,
      title: "Leaving the House of Horrors",
      audio: null,
    },
    {
      id: 70,
      imgSrc: NeededSurgery,
      thumbSrc: `/.netlify/images?url=${NeededSurgery}&w=400`,
      title: "A Much Needed Surgery for Mr. Potato Head",
      audio: null,
    },
    {
      id: 71,
      imgSrc: SafeTravel,
      thumbSrc: `/.netlify/images?url=${SafeTravel}&w=400`,
      title: "Safe Travel",
      audio: null,
    },
    {
      id: 72,
      imgSrc: BlackHole,
      thumbSrc: `/.netlify/images?url=${BlackHole}&w=400`,
      title: "New Arrival Through the Black Hole",
      audio: null,
    },
    {
      id: 73,
      imgSrc: MaryPoppins,
      thumbSrc: `/.netlify/images?url=${MaryPoppins}&w=400`,
      title: "The Martian Mary Poppins",
      audio: null,
    },
    {
      id: 74,
      imgSrc: RecentTimes,
      thumbSrc: `/.netlify/images?url=${RecentTimes}&w=400`,
      title: "The Fool in Recent Times",
      audio: null,
    },
    {
      id: 75,
      imgSrc: Homecoming,
      thumbSrc: `/.netlify/images?url=${Homecoming}&w=400`,
      title: "Homecoming for the Other Lost Tambourine Section",
      audio: null,
    },
    {
      id: 76,
      imgSrc: KindredSpirits,
      thumbSrc: `/.netlify/images?url=${KindredSpirits}&w=400`,
      title: "Kindred Spirits",
      audio:null,
    },
    {
      id: 77,
      imgSrc: Flip,
      thumbSrc: `/.netlify/images?url=${Flip}&w=400`,
      title: "Flip",
      audio: null,
    },
    {
      id: 78,
      imgSrc: YouFirst,
      thumbSrc: `/.netlify/images?url=${YouFirst}&w=400`,
      title: "You First",
      audio: null,
    },
    {
      id: 79,
      imgSrc: Afternoon,
      thumbSrc: `/.netlify/images?url=${Afternoon}&w=400`,
      title: "Another Afternoon at Lucille's Pool Hall",
      audio: null,
    },
    {
      id: 80,
      imgSrc: BirdSanctuary,
      thumbSrc: `/.netlify/images?url=${BirdSanctuary}&w=400`,
      title: "To the Bird Sanctuary",
      audio: null,
    },
    {
      id: 81,
      imgSrc: Neptunes1,
      thumbSrc: `/.netlify/images?url=${Neptunes1}&w=400`,
      title: "The Neptunes Confront Us About the Pollution",
      audio: null,
    },
    {
      id: 82,
      imgSrc: Wrestling,
      thumbSrc: `/.netlify/images?url=${Wrestling}&w=400`,
      title: "Jacob Wrestling the Angel",
      audio: null,
    },
    {
      id: 83,
      imgSrc: LastVoyage,
      thumbSrc: `/.netlify/images?url=${LastVoyage}&w=400`,
      title: "The Last Voyage of the Queen Mother",
      audio: null,
    },
    {
      id: 84,
      imgSrc: Enlightenment,
      thumbSrc: `/.netlify/images?url=${Enlightenment}&w=400`,
      title: "Moment of Enlightenment",
      audio: null,
    },
    {
      id: 85,
      imgSrc: Try,
      thumbSrc: `/.netlify/images?url=${Try}&w=400`,
      title: "You Have to Try",
      audio: null,
    },
    {
      id: 86,
      imgSrc: Practice,
      thumbSrc: `/.netlify/images?url=${Practice}&w=400`,
      title: "Practice",
      audio: null,
    },
    {
      id: 87,
      imgSrc: BetterThan,
      thumbSrc: `/.netlify/images?url=${BetterThan}&w=400`,
      title: "You Can Do Better Than That",
      audio: null,
    },
    {
      id: 88,
      imgSrc: Direction,
      thumbSrc: `/.netlify/images?url=${Direction}&w=400`,
      title: "Choose Your Direction",
      audio: null,
    },
    {
      id: 89,
      imgSrc: PastBehind,
      thumbSrc: `/.netlify/images?url=${PastBehind}&w=400`,
      title: "Leaving the Past Behind",
      audio: PastBehindAudio,
    },
    {
      id: 90,
      imgSrc: Sad,
      thumbSrc: `/.netlify/images?url=${Sad}&w=400`,
      title: "Sad",
      audio: null,
    },
    {
      id: 91,
      imgSrc: Lost,
      thumbSrc: `/.netlify/images?url=${Lost}&w=400`,
      title: "Lost Between the Planets",
      audio: null,
    },
    {
      id: 92,
      imgSrc: Untitled92,
      thumbSrc: `/.netlify/images?url=${Untitled92}&w=400`,
      title: "Untitled",
      audio: null,
    },
    {
      id: 93,
      imgSrc: Realities,
      thumbSrc: `/.netlify/images?url=${Realities}&w=400`,
      title: "Different Realities",
      audio: null,
    },
    {
      id: 94,
      imgSrc: RiverStyx,
      thumbSrc: `/.netlify/images?url=${RiverStyx}&w=400`,
      title: "This Side of the River Styx",
      audio: null,
    },
    {
      id: 95,
      imgSrc: Dorothy,
      thumbSrc: `/.netlify/images?url=${Dorothy}&w=400`,
      title: "Dorothy",
      audio: null,
    },
    {
      id: 96,
      imgSrc: SunnySide,
      thumbSrc: `/.netlify/images?url=${SunnySide}&w=400`,
      title: "Sunny Side Up",
      audio: SunnySideAudio,
    },
    {
      id: 97,
      imgSrc: JacobsDream,
      thumbSrc: `/.netlify/images?url=${JacobsDream}&w=400`,
      title: "Jacob's Dream",
      audio: null,
    },
    {
      id: 98,
      imgSrc: LunchReady,
      thumbSrc: `/.netlify/images?url=${LunchReady}&w=400`,
      title: "Lunch Is Ready",
      audio: null,
    },
    {
      id: 99,
      imgSrc: RedRope,
      thumbSrc: `/.netlify/images?url=${RedRope}&w=400`,
      title: "Red Rope",
      audio: null,
    },
    {
      id: 100,
      imgSrc: SeeMe,
      thumbSrc: `/.netlify/images?url=${SeeMe}&w=400`,
      title: "Can You See Me?",
      audio: null,
    },
    {
      id: 101,
      imgSrc: TheUnknown,
      thumbSrc: `/.netlify/images?url=${TheUnknown}&w=400`,
      title: "Into the Unknown",
      audio: null,
    },
    {
      id: 102,
      imgSrc: NoFriends,
      thumbSrc: `/.netlify/images?url=${NoFriends}&w=400`,
      title: "She Had No Friends",
      audio: null,
    },
    {
      id: 103,
      imgSrc: ButterflyWoman,
      thumbSrc: `/.netlify/images?url=${ButterflyWoman}&w=400`,
      title: "Butterfly Woman",
      audio: null,
    },
    {
      id: 104,
      imgSrc: Gifts,
      thumbSrc: `/.netlify/images?url=${Gifts}&w=400`,
      title: "Gifts",
      audio: null,
    },
    {
      id: 105,
      imgSrc: Guardian,
      thumbSrc: `/.netlify/images?url=${Guardian}&w=400`,
      title: "Guardian",
      audio: null,
    },
    {
      id: 106,
      imgSrc: Purification,
      thumbSrc: `/.netlify/images?url=${Purification}&w=400`,
      title: "Purification of Thought",
      audio: null,
    },
    {
      id: 107,
      imgSrc: Resist,
      thumbSrc: `/.netlify/images?url=${Resist}&w=400`,
      title: "Resistance",
      audio: ResistanceAudio,
    },
    {
      id: 108,
      imgSrc: Surgery2,
      thumbSrc: `/.netlify/images?url=${Surgery2}&w=400`,
      title: "Reconstructive Surgery",
      audio: SurgeryAudio,
    },
    {
      id: 109,
      imgSrc: Crossroads,
      thumbSrc: `/.netlify/images?url=${Crossroads}&w=400`,
      title: "Meeting the Devil at the Crossroads With My Cello",
      audio: null,
    },
    {
      id: 110,
      imgSrc: BullRing,
      thumbSrc: `/.netlify/images?url=${BullRing}&w=400`,
      title: "Retired From the Bull Ring",
      audio: null,
    },
    {
      id: 111,
      imgSrc: KingCats,
      thumbSrc: `/.netlify/images?url=${KingCats}&w=400`,
      title: "King of the Cats",
      audio: null,
    },
    {
      id: 112,
      imgSrc: EggedOn,
      thumbSrc: `/.netlify/images?url=${EggedOn}&w=400`,
      title: "Egged On",
      audio: null,
    },
    {
      id: 113,
      imgSrc: TooFar,
      thumbSrc: `/.netlify/images?url=${TooFar}&w=400`,
      title: "This Time You've Gone Too Far",
      audio: TooFarAudio,
    },
    {
      id: 114,
      imgSrc: LookingAhead,
      thumbSrc: `/.netlify/images?url=${LookingAhead}&w=400`,
      title: "Looking Ahead",
      audio: null,
    },
    {
      id: 115,
      imgSrc: Opera,
      thumbSrc: `/.netlify/images?url=${Opera}&w=400`,
      title: "Opera (View From the Mezzanine?)",
      audio: null,
    },
    {
      id: 116,
      imgSrc: StateOfWorld,
      thumbSrc: `/.netlify/images?url=${StateOfWorld}&w=400`,
      title: "The State of the World",
      audio: StateOfWorldAudio,
    },
    {
      id: 117,
      imgSrc: GiantEgg,
      thumbSrc: `/.netlify/images?url=${GiantEgg}&w=400`,
      title: "Passing the Giant Egg",
      audio: null,
    },
    {
      id: 118,
      imgSrc: OuttaHere,
      thumbSrc: `/.netlify/images?url=${OuttaHere}&w=400`,
      title: "I'm Outta Here",
      audio: OuttaHereAudio,
    },
    {
      id: 119,
      imgSrc: PaintersMuseum,
      thumbSrc: `/.netlify/images?url=${PaintersMuseum}&w=400`,
      title: "The Painter's Museum",
      audio: MuseumAudio,
    },
    {
      id: 120,
      imgSrc: PrivateShowing,
      thumbSrc: `/.netlify/images?url=${PrivateShowing}&w=400`,
      title: "Private Showing",
      audio: ShowingAudio,
    },
    {
      id: 121,
      imgSrc: Roadhouse,
      thumbSrc: `/.netlify/images?url=${Roadhouse}&w=400`,
      title: "The Roadhouse at the Full Moon",
      audio: RoadhouseAudio,
    },
    {
      id: 122,
      imgSrc: CenterStage,
      thumbSrc: `/.netlify/images?url=${CenterStage}&w=400`,
      title: "Center Stage",
      audio: null,
    },
    {
      id: 123,
      imgSrc: Conservationist,
      thumbSrc: `/.netlify/images?url=${Conservationist}&w=400`,
      title: "Conservationist",
      audio: null,
    },
    {
      id: 124,
      imgSrc: Traveler,
      thumbSrc: `/.netlify/images?url=${Traveler}&w=400`,
      title: "Spiritual Tourist",
      audio: SpiritualTouristAudio,
    },
    {
      id: 125,
      imgSrc: GoodCheer,
      thumbSrc: `/.netlify/images?url=${GoodCheer}&w=400`,
      title: "Be of Good Cheer",
      audio: null,
    },
    {
      id: 126,
      imgSrc: YearsLater,
      thumbSrc: `/.netlify/images?url=${YearsLater}&w=400`,
      title: "Years Later He Lit up a Cigarette",
      audio: null,
    },
    {
      id: 127,
      imgSrc: Bob,
      thumbSrc: `/.netlify/images?url=${Bob}&w=400`,
      title: "Bob",
      audio: null,
    },
    {
      id: 128,
      imgSrc: QuestionableMoves,
      thumbSrc: `/.netlify/images?url=${QuestionableMoves}&w=400`,
      title: "Questionable Moves",
      audio: QuestionableMovesAudio,
    },
    {
      id: 129,
      imgSrc: BackToSea,
      thumbSrc: `/.netlify/images?url=${BackToSea}&w=400`,
      title: "Go Back to Sea",
      audio: null,
    },
    {
      id: 130,
      imgSrc: Dubious,
      thumbSrc: `/.netlify/images?url=${Dubious}&w=400`,
      title: "Dubious",
      audio: null,
    },
    {
      id: 131,
      imgSrc: Dervish1,
      thumbSrc: `/.netlify/images?url=${Dervish1}&w=400`,
      title: "Dervish 1",
      audio: null,
    },
    {
      id: 132,
      imgSrc: Dervish2,
      thumbSrc: `/.netlify/images?url=${Dervish2}&w=400`,
      title: "Dervish 2",
      audio: null,
    },
    {
      id: 133,
      imgSrc: Helena,
      thumbSrc: `/.netlify/images?url=${Helena}&w=400`,
      title: "Helena",
      audio: null,
    },
    {
      id: 134,
      imgSrc: DealWithDevil,
      thumbSrc: `/.netlify/images?url=${DealWithDevil}&w=400`,
      title: "The Soul Breaks the Deal with the Devil",
      audio: null,
    },
    {
      id: 135,
      imgSrc: Waiting,
      thumbSrc: `/.netlify/images?url=${Waiting}&w=400`,
      title: "Waiting for the Parting",
      audio: ThePartingAudio,
    },
    {
      id: 136,
      imgSrc: Higher,
      thumbSrc: `/.netlify/images?url=${Higher}&w=400`,
      title: "Higher",
      audio: HigherAudio,
    },
    {
      id: 137,
      imgSrc: OhJesus,
      thumbSrc: `/.netlify/images?url=${OhJesus}&w=400`,
      title: "Oh, Jesus Christ",
      audio: JesusChristAudio,
    },
    {
      id: 138,
      imgSrc: Probed,
      thumbSrc: `/.netlify/images?url=${Probed}&w=400`,
      title: "Probed",
      audio: ProbedAudio,
    },
    {
      id: 139,
      imgSrc: DevilsRing,
      thumbSrc: `/.netlify/images?url=${DevilsRing}&w=400`,
      title: "Playing for the Devil's Ring",
      audio: DevilsRingAudio,
    },
    {
      id: 140,
      imgSrc: DayBeach,
      thumbSrc: `/.netlify/images?url=${DayBeach}&w=400`,
      title: "Another Day at the Beach",
      audio: BeachAudio,
    },
    {
      id: 141,
      imgSrc: Mutiny,
      thumbSrc: `/.netlify/images?url=${Mutiny}&w=400`,
      title: "Mutiny",
      audio: MutinyAudio,
    },
    {
      id: 142,
      imgSrc: CatchRelease,
      thumbSrc: `/.netlify/images?url=${CatchRelease}&w=400`,
      title: "Catch and Release",
      audio: null,
    },
    {
      id: 143,
      imgSrc: WhiteClown2,
      thumbSrc: `/.netlify/images?url=${WhiteClown2}&w=400`,
      title: "White Clown 2",
      audio: null,
    },
    {
      id: 144,
      imgSrc: Dervish3,
      thumbSrc: `/.netlify/images?url=${Dervish3}&w=400`,
      title: "Dervish 3",
      audio: null,
    },
    {
      id: 145,
      imgSrc: Jester,
      thumbSrc: `/.netlify/images?url=${Jester}&w=400`,
      title: "Jester",
      audio: null,
    },
    {
      id: 146,
      imgSrc: Untitled,
      thumbSrc: `/.netlify/images?url=${Untitled}&w=400`,
      title: "Untitled",
      audio: null,
    },
    {
      id: 147,
      imgSrc: FlightSchool,
      thumbSrc: `/.netlify/images?url=${FlightSchool}&w=400`,
      title: "Flight School",
      audio: null,
    },
    {
      id: 148,
      imgSrc: BreakfastChef,
      thumbSrc: `/.netlify/images?url=${BreakfastChef}&w=400`,
      title: "Breakfast Chef",
      audio: null,
    },
    {
      id: 149,
      imgSrc: LeavingHome,
      thumbSrc: `/.netlify/images?url=${LeavingHome}&w=400`,
      title: "She's Leaving Home",
      audio: null,
    },
    {
      id: 150,
      imgSrc: MuseumDisasters,
      thumbSrc: `/.netlify/images?url=${MuseumDisasters}&w=400`,
      title: "The Museum of Disasters (He Went Down With the Ship)",
      audio: null,
    },
    {
      id: 151,
      imgSrc: Brunhilda,
      thumbSrc: `/.netlify/images?url=${Brunhilda}&w=400`,
      title: "Brunhilda",
      audio: null,
    },
    {
      id: 152,
      imgSrc: PayAdvance,
      thumbSrc: `/.netlify/images?url=${PayAdvance}&w=400`,
      title: "Pay in Advance",
      audio: null,
    },
    {
      id: 153,
      imgSrc: Arrival,
      thumbSrc: `/.netlify/images?url=${Arrival}&w=400`,
      title: "Arrival",
      audio: null,
    },
    {
      id: 154,
      imgSrc: BetterPlace,
      thumbSrc: `/.netlify/images?url=${BetterPlace}&w=400`,
      title: "A Better Place",
      audio: null,
    },
    {
      id: 155,
      imgSrc: InReadiness,
      thumbSrc: `/.netlify/images?url=${InReadiness}&w=400`,
      title: "In Readiness",
      audio: null,
    },
    {
      id: 156,
      imgSrc: CheckMate,
      thumbSrc: `/.netlify/images?url=${CheckMate}&w=400`,
      title: "Check Mate",
      audio: null,
    },
    {
      id: 157,
      imgSrc: Doctors,
      thumbSrc: `/.netlify/images?url=${Doctors}&w=400`,
      title: "A Fear of Doctors",
      audio: null,
    },
    {
      id: 158,
      imgSrc: TheChariot,
      thumbSrc: `/.netlify/images?url=${TheChariot}&w=400`,
      title: "The Chariot (From the Tarot)",
      audio: null,
    },
    {
      id: 159,
      imgSrc: OutOfReach,
      thumbSrc: `/.netlify/images?url=${OutOfReach}&w=400`,
      title: "Out of Reach",
      audio: null,
    },
    {
      id: 160,
      imgSrc: Red,
      thumbSrc: `/.netlify/images?url=${Red}&w=400`,
      title: "Red",
      audio: null,
    },
    {
      id: 161,
      imgSrc: Surprised,
      thumbSrc: `/.netlify/images?url=${Surprised}&w=400`,
      title: "Surprised",
      audio: null,
    },
    {
      id: 162,
      imgSrc: WithBrother,
      thumbSrc: `/.netlify/images?url=${WithBrother}&w=400`,
      title: "The Trip With My Brother",
      audio: null,
    },
    {
      id: 163,
      imgSrc: BestOfShow,
      thumbSrc: `/.netlify/images?url=${BestOfShow}&w=400`,
      title: "Best of Show",
      audio: null,
    },
    {
      id: 164,
      imgSrc: Sainted,
      thumbSrc: `/.netlify/images?url=${Sainted}&w=400`,
      title: "Sainted",
      audio: null,
    },
    {
      id: 165,
      imgSrc: SixDogs,
      thumbSrc: `/.netlify/images?url=${SixDogs}&w=400`,
      title: "I've Had Six Dogs",
      audio: null,
    },
    {
      id: 166,
      imgSrc: Fighting,
      thumbSrc: `/.netlify/images?url=${Fighting}&w=400`,
      title: "We Were Fighting at the Time of the Comet",
      audio: null,
    },
    {
      id: 167,
      imgSrc: Sense,
      thumbSrc: `/.netlify/images?url=${Sense}&w=400`,
      title: "Nothing Makes Sense",
      audio: null,
    },
    {
      id: 168,
      imgSrc: Going,
      thumbSrc: `/.netlify/images?url=${Going}&w=400`,
      title: "Where Are You Going?",
      audio: null,
    },
    {
      id: 169,
      imgSrc: Eggs,
      thumbSrc: `/.netlify/images?url=${Eggs}&w=400`,
      title: "Eggs",
      audio: null,
    },
    {
      id: 170,
      imgSrc: MotherRocket,
      thumbSrc: `/.netlify/images?url=${MotherRocket}&w=400`,
      title: "No Mother, I Told You to Stay On the Rocket Ship",
      audio: null,
    },
    {
      id: 171,
      imgSrc: Divas,
      thumbSrc: `/.netlify/images?url=${Divas}&w=400`,
      title: "When Divas Are Escorted by Drunks",
      audio: null,
    },
    {
      id: 172,
      imgSrc: ColdWind,
      thumbSrc: `/.netlify/images?url=${ColdWind}&w=400`,
      title: "A Cold Wind",
      audio: null,
    },
    {
      id: 173,
      imgSrc: Voices,
      thumbSrc: `/.netlify/images?url=${Voices}&w=400`,
      title: "Voices of Doom",
      audio: null,
    },
    {
      id: 174,
      imgSrc: Matrimony,
      thumbSrc: `/.netlify/images?url=${Matrimony}&w=400`,
      title: "Unholy Matrimony",
      audio: null,
    },
    {
      id: 175,
      imgSrc: Anger,
      thumbSrc: `/.netlify/images?url=${Anger}&w=400`,
      title: "Anger",
      audio: null,
    },
    {
      id: 176,
      imgSrc: Overqualified,
      thumbSrc: `/.netlify/images?url=${Overqualified}&w=400`,
      title: "Overqualified",
      audio: null,
    },
    {
      id: 177,
      imgSrc: Peghead,
      thumbSrc: `/.netlify/images?url=${Peghead}&w=400`,
      title: "Peghead",
      audio: null,
    },
    {
      id: 178,
      imgSrc: Decoration,
      thumbSrc: `/.netlify/images?url=${Decoration}&w=400`,
      title: "Decoration",
      audio: null,
    },
    {
      id: 179,
      imgSrc: ReEntry,
      thumbSrc: `/.netlify/images?url=${ReEntry}&w=400`,
      title: "Re-Entry Was Rough",
      audio: null,
    },
    {
      id: 180,
      imgSrc: Wiser,
      thumbSrc: `/.netlify/images?url=${Wiser}&w=400`,
      title: "Older but Wiser",
      audio: null,
    },
    {
      id: 181,
      imgSrc: Worker,
      thumbSrc: `/.netlify/images?url=${Worker}&w=400`,
      title: "Catch and Release",
      audio: null,
    },
    {
      id: 182,
      imgSrc: Demo,
      thumbSrc: `/.netlify/images?url=${Demo}&w=400`,
      title: "Demo",
      audio: null,
    },
    {
      id: 183,
      imgSrc: BentNote,
      thumbSrc: `/.netlify/images?url=${BentNote}&w=400`,
      title: "Receiving the Bent Note",
      audio: null,
    },
    {
      id: 184,
      imgSrc: WhatSound,
      thumbSrc: `/.netlify/images?url=${WhatSound}&w=400`,
      title: "What Was That Sound",
      audio: null,
    },
    {
      id: 185,
      imgSrc: Downstairs,
      thumbSrc: `/.netlify/images?url=${Downstairs}&w=400`,
      title: "Going Downstairs for Ideas",
      audio: null,
    },
    {
      id: 186,
      imgSrc: Gossip,
      thumbSrc: `/.netlify/images?url=${Gossip}&w=400`,
      title: "The Paint Hadn't Even Dried at the Wedding and Already There Was Gossip",
      audio: null,
    },
    {
      id: 187,
      imgSrc: Heirophant,
      thumbSrc: `/.netlify/images?url=${Heirophant}&w=400`,
      title: "The Heirophant (From the Tarot)",
      audio: null,
    },
    {
      id: 188,
      imgSrc: WomanInCharge,
      thumbSrc: `/.netlify/images?url=${WomanInCharge}&w=400`,
      title: "Put a Woman in Charge",
      audio: null,
    },
    {
      id: 189,
      imgSrc: Devil,
      thumbSrc: `/.netlify/images?url=${Devil}&w=400`,
      title: "The Devil",
      audio: null,
    },
    {
      id: 190,
      imgSrc: Untitled2,
      thumbSrc: `/.netlify/images?url=${Untitled2}&w=400`,
      title: "Untitled",
      audio: null,
    },
    {
      id: 191,
      imgSrc: WheelFortune,
      thumbSrc: `/.netlify/images?url=${WheelFortune}&w=400`,
      title: "The Wheel of Fortune (From the Tarot)",
      audio: null,
    },
    {
      id: 192,
      imgSrc: Justice,
      thumbSrc: `/.netlify/images?url=${Justice}&w=400`,
      title: "Justice",
      audio: null,
    },
    {
      id: 193,
      imgSrc: Untitled3,
      thumbSrc: `/.netlify/images?url=${Untitled3}&w=400`,
      title: "Untitled",
      audio: null,
    },
    {
      id: 194,
      imgSrc: HelpArrives,
      thumbSrc: `/.netlify/images?url=${HelpArrives}&w=400`,
      title: "Help Arrives",
      audio: null,
    },
    {
      id: 195,
      imgSrc: Tooth,
      thumbSrc: `/.netlify/images?url=${Tooth}&w=400`,
      title: "Tooth",
      audio: null,
    },
    {
      id: 196,
      imgSrc: Bill,
      thumbSrc: `/.netlify/images?url=${Bill}&w=400`,
      title: "Bill",
      audio: null,
    },
    {
      id: 197,
      imgSrc: OtherSide,
      thumbSrc: `/.netlify/images?url=${OtherSide}&w=400`,
      title: "The Other Side",
      audio: OtherSideAudio,
    },
    {
      id: 198,
      imgSrc: RiseAbove,
      thumbSrc: `/.netlify/images?url=${RiseAbove}&w=400`,
      title: "Rise Above",
      audio: null,
    },
    {
      id: 199,
      imgSrc: Misgivings,
      thumbSrc: `/.netlify/images?url=${Misgivings}&w=400`,
      title: "Misgivings Over His Hat",
      audio: null,
    },
    {
      id: 200,
      imgSrc: Medicine,
      thumbSrc: `/.netlify/images?url=${Medicine}&w=400`,
      title: "Take Your Medicine",
      audio: null,
    },
    {
      id: 201,
      imgSrc: SongOfLove,
      thumbSrc: `/.netlify/images?url=${SongOfLove}&w=400`,
      title: "The Song of Love",
      audio: SongOfLoveAudio,
    },
    {
      id: 202,
      imgSrc: DashedDreams,
      thumbSrc: `/.netlify/images?url=${DashedDreams}&w=400`,
      title: "Reflecing on the Dashed Dreams of Arcosanti",
      audio: null,
    },
    {
      id: 203,
      imgSrc: TooLate,
      thumbSrc: `/.netlify/images?url=${TooLate}&w=400`,
      title: "Too Late",
      audio: null,
    },
    {
      id: 204,
      imgSrc: Beatrice,
      thumbSrc: `/.netlify/images?url=${Beatrice}&w=400`,
      title: "Beatrice",
      audio: null,
    },
    {
      id: 205,
      imgSrc: Danger,
      thumbSrc: `/.netlify/images?url=${Danger}&w=400`,
      title: "Danger",
      audio: null,
    },
    {
      id: 206,
      imgSrc: Rendezvous,
      thumbSrc: `/.netlify/images?url=${Rendezvous}&w=400`,
      title: "Midnight Rendezvous",
      audio: null,
    },
    {
      id: 207,
      imgSrc: Cooks,
      thumbSrc: `/.netlify/images?url=${Cooks}&w=400`,
      title: "Cooks on Break",
      audio: null,
    },
    {
      id: 208,
      imgSrc: Autumn33,
      thumbSrc: `/.netlify/images?url=${Autumn33}&w=400`,
      title: "The Autumn of '33",
      audio: AutumnAudio,
    },
    {
      id: 209,
      imgSrc: EntertainmentChange,
      thumbSrc: `/.netlify/images?url=${EntertainmentChange}&w=400`,
      title: "The Entertainment at Climate Change",
      audio: null,
    },
    {
      id: 210,
      imgSrc: ToMexico,
      thumbSrc: `/.netlify/images?url=${ToMexico}&w=400`,
      title: "To Mexico",
      audio: null,
    },
    {
      id: 211,
      imgSrc: GoldenMountain,
      thumbSrc: `/.netlify/images?url=${GoldenMountain}&w=400`,
      title: "Marathon to Golden Mountain",
      audio: null,
    },
    {
      id: 212,
      imgSrc: ClimateChange,
      thumbSrc: `/.netlify/images?url=${ClimateChange}&w=400`,
      title: "Climate Change on Your Vacation",
      audio: null,
    },
    {
      id: 213,
      imgSrc: Untitled4,
      thumbSrc: `/.netlify/images?url=${Untitled4}&w=400`,
      title: "Untitled",
      audio: null,
    },
    {
      id: 214,
      imgSrc: Marge,
      thumbSrc: `/.netlify/images?url=${Marge}&w=400`,
      title: "Marge",
      audio: null,
    },
    {
      id: 215,
      imgSrc: Judgement,
      thumbSrc: `/.netlify/images?url=${Judgement}&w=400`,
      title: "Judgement (From the Tarot)",
      audio: null,
    },
    {
      id: 216,
      imgSrc: Untitled6,
      thumbSrc: `/.netlify/images?url=${Untitled6}&w=400`,
      title: "Untitled",
      audio: null,
    },
    {
      id: 217,
      imgSrc: Transparent,
      thumbSrc: `/.netlify/images?url=${Transparent}&w=400`,
      title: "Transparent",
      audio: null,
    },
    {
      id: 218,
      imgSrc: Stunned,
      thumbSrc: `/.netlify/images?url=${Stunned}&w=400`,
      title: "Stunned by the Beauty of Night",
      audio: null,
    },
    {
      id: 219,
      imgSrc: Transport,
      thumbSrc: `/.netlify/images?url=${Transport}&w=400`,
      title: "Transport to a Better Place",
      audio: null,
    },
    {
      id: 220,
      imgSrc: NoSmoking,
      thumbSrc: `/.netlify/images?url=${NoSmoking}&w=400`,
      title: "No Smoking Here",
      audio: null,
    },
    {
      id: 221,
      imgSrc: Death,
      thumbSrc: `/.netlify/images?url=${Death}&w=400`,
      title: "Death (From the Tarot)",
      audio: null,
    },
    {
      id: 222,
      imgSrc: Sherpa,
      thumbSrc: `/.netlify/images?url=${Sherpa}&w=400`,
      title: "The Sherpa",
      audio: TheSherpaAudio,
    },
    {
      id: 223,
      imgSrc: Flocking,
      thumbSrc: `/.netlify/images?url=${Flocking}&w=400`,
      title: "People Flocking to the Painter's Museum",
      audio: null,
    },
    {
      id: 224,
      imgSrc: PaintMeHappy,
      thumbSrc: `/.netlify/images?url=${PaintMeHappy}&w=400`,
      title: "Paint Me Happy",
      audio: null,
    },
    {
      id: 225,
      imgSrc: Go,
      thumbSrc: `/.netlify/images?url=${Go}&w=400`,
      title: "Go!",
      audio: null,
    },
    {
      id: 226,
      imgSrc: DontWorry,
      thumbSrc: `/.netlify/images?url=${DontWorry}&w=400`,
      title: "Don't Worry, Be Happy",
      audio: null,
    },
    {
      id: 227,
      imgSrc: Advice,
      thumbSrc: `/.netlify/images?url=${Advice}&w=400`,
      title: "We Could Use Some Advice",
      audio: null,
    },
    {
      id: 228,
      imgSrc: NaturalHistory,
      thumbSrc: `/.netlify/images?url=${NaturalHistory}&w=400`,
      title: "The Museum of Natural History",
      audio: null,
    },
    {
      id: 229,
      imgSrc: Conclave,
      thumbSrc: `/.netlify/images?url=${Conclave}&w=400`,
      title: "Conclave",
      audio: null,
    },
    {
      id: 230,
      imgSrc: Quarantined,
      thumbSrc: `/.netlify/images?url=${Quarantined}&w=400`,
      title: "Quarantined With Someone You Disagree With",
      audio: null,
    },
  ]